import { throttle } from "lodash";

export const getOpacity = throttle(
  (sliderValue: number) => {
    const clamped = Math.max(0, Math.min(100, sliderValue));

    const minOpacity = 80;
    const maxOpacity = 100;

    const opacity = Math.round(maxOpacity - (clamped / 100) * (maxOpacity - minOpacity));

    return opacity / 100;
  },
  50,
  {
    leading: true,
    trailing: true,
  },
);
